module.exports={
    "home": "https://iamscottxu.github.io/openBSE/",
    "name": "openBSE",
    "description": "openBSE is a high-performance JavaScript bullet-screen (danmaku) engine.",
    "buildDate": "Thu, 21 Jan 2021 15:59:41 GMT",
    "version": "3.3.0"
}